import React from 'react';

import {Label} from '../index';
import {SmallArrowheadBackward, SmallArrowheadForward} from '../../styles/icons';

const Pagination = (props) => {
    const {currentPage, totalPages, updatePage, scrollToElementID} = props;

    const scrollToElement = (elementId) => {
        const posY =
            document.getElementById(elementId) &&
            document.getElementById(elementId).offsetTop - (window.innerWidth < 1014 ? -15 : 45);
        elementId && window.scrollTo({behavior: 'smooth', top: posY});
    };

    return (
        <div className='pagination d-flex align-items-center justify-content-center mt-4'>
            <span
                className={`px-2 ${currentPage > 1 ? 'cursor-pointer' : ''}`}
                onClick={() => {
                    if (currentPage > 1) {
                        updatePage(currentPage - 1);
                        scrollToElement(scrollToElementID);
                    }
                }}
            >
                <SmallArrowheadBackward />
            </span>
            <Label
                labelData={currentPage}
                labelClass='d-flex align-items-center justify-content-center current-page m-0 mx-1 maxis fs-18 text-gunmetal'
            />
            <Label labelData='of' labelClass='m-0 mx-1 maxis fs-18 text-gunmetal' />
            <Label labelData={totalPages} labelClass='m-0 mx-1 maxis fs-18 text-gunmetal' />
            <span
                className={`px-2 ${currentPage < totalPages ? 'cursor-pointer' : ''}`}
                onClick={() => {
                    if (currentPage < totalPages) {
                        updatePage(currentPage + 1);
                        scrollToElement(scrollToElementID);
                    }
                }}
            >
                <SmallArrowheadForward />
            </span>
        </div>
    );
};
export default Pagination;
